module.exports = __webpack_public_path__ + "assets/logo_dtcc--black.37038c61.svg";